import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4432a957&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4432a957')) {
      api.createRecord('4432a957', component.options)
    } else {
      api.reload('4432a957', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4432a957&", function () {
      api.rerender('4432a957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/List.vue"
export default component.exports